import { Component } from '@angular/core';
import {Countries, TalentProfilePage } from "../../../enums";
import { PageService } from "../shared/page-service";
import { TalentHappyPathDataService } from "../../shared/service/talent-happy-path-data-service";
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-talent-profile-container',
  standalone: false,
  templateUrl: './talent-profile-container.component.html',
  styleUrl: './talent-profile-container.component.scss'
})
export class TalentProfileContainerComponent {
  TalentProfilePage = TalentProfilePage;
  activePage = TalentProfilePage.EMPLOYMENT_PREFERENCES;
  totalPages = 5;
  postingInfo: PostingInfo;
  isGeneralApplication: boolean = false;
  public headerText: string;
  private talent: Talent;
  private talentHomeMarketCountryId: number;

  constructor(private pageService: PageService,
              private talentHappyPathDataService: TalentHappyPathDataService,
              private translate: TranslateService,
              private router: Router) {}

  ngOnInit() {
    this.talentHomeMarketCountryId = this.talentHappyPathDataService.homeMarketCountryId ?? this.talentHappyPathDataService.postingInfo?.countryId;
    if (this.talentHomeMarketCountryId === undefined || this.talentHomeMarketCountryId === 0 || this.talentHomeMarketCountryId === null) {
      this.talent = this.talentHappyPathDataService.talent;
      if (this.talent?.countryId === Countries.USA || this.talent?.countryId === Countries.DE || this.talent?.countryId === Countries.AU) {
        this.totalPages = 4;
        this.talentHappyPathDataService.homeMarketCountryId = this.talent.countryId;
      }
    } else {
      if (this.talentHomeMarketCountryId === Countries.USA || this.talentHomeMarketCountryId === Countries.DE || this.talentHomeMarketCountryId === Countries.AU) {
        this.totalPages = 4;
      }
    }

    this.isGeneralApplication = this.talentHappyPathDataService.isGeneralApplication;
    if (this.talentHappyPathDataService.gather) {
      if (this.talentHomeMarketCountryId === Countries.USA || this.talentHomeMarketCountryId === Countries.AU) {
        this.router.navigateByUrl('/thank-you', {skipLocationChange: true});
      } else {
        this.pageService.setActivePage(TalentProfilePage.TALENT_EEOC);
      }
    }

    this.pageService.activePage$.subscribe(page => this.activePage = page);
    this.postingInfo = this.talentHappyPathDataService.postingInfo;
    this.setHeaderText();
  }

  setActivePage(page: TalentProfilePage) {
    this.pageService.setActivePage(page);
  }

  getActivePageNumber() {
    return this.activePage;
  }

  getCompletionPercentage() {
    return (this.activePage / this.totalPages) * 100;
  }

  isFromGather(): boolean {
    return this.talentHappyPathDataService.gather && this.talentHappyPathDataService.gather != null;
  }

  setHeaderText(): void {
    if (this.isGeneralApplication) {
      this.headerText = this.translate.instant('talent-happy-path.general-application.header-text');
    } else {
      this.headerText = this.postingInfo?.jobTitle ? this.postingInfo.jobTitle : '';
    }
  }
}
